import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import QRCode from "./pages/QRCode/QRCode";

const router = createBrowserRouter([
  {
    path: "/",
    element: <div>Hello world!</div>,
  },
  {
    path: "/qr",
    element: <QRCode />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
